function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 6.651v10.682C22 18.802 20.775 20 19.273 20H4.727C3.225 20 2 18.802 2 17.333V6.65C2.01 5.19 3.23 4 4.727 4h14.546C20.769 4 21.99 5.19 22 6.651zm-1.915-.38a.917.917 0 00-.812-.493H4.727a.917.917 0 00-.812.492L12 11.804l8.085-5.534zm.097 2.103l-7.66 5.243a.926.926 0 01-1.043 0l-7.66-5.243v8.96c0 .486.41.888.908.888h14.546a.904.904 0 00.909-.889v-8.96z"
});

var SvgMail = function SvgMail(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mail.77b27be5.svg";
export { SvgMail as ReactComponent };